// Domain/Repositories/MovimientoInventarioRepository.js

/**
 * Contrato del repositorio de movimientos de inventario
 * Define las operaciones que debe implementar la infraestructura
 */
export class MovimientoInventarioRepositoryInterface {

  /**
   * Inserta un movimiento de inventario
   * @param {Object} movimiento
   * @returns {Promise<Object>}
   */
  async insertarMovimientoInventario(movimiento) {
    throw new Error("Metodo repository interface no implementado");
  }

  /**
   * Obtiene movimientos según filtros
   * @param {Object} filtros
   * @returns {Promise<Array>}
   */
  async obtenerMovimientoInventario(filtros = {}) {
    throw new Error("Metodo repository interface no implementado");
  }

}